<template>
    <div style="flex: 1; margin: 50px; max-width: 550px;">
        <el-skeleton :rows="5" animated />
    </div>
</template>